export const paymentIcons: Record<string, string> = {
  // 💳 Card Brands (Stripe brand values)
  visa: "/icons/visa.svg",
  mastercard: "/icons/mastercard.svg",
  amex: "/icons/american-express.svg",
  diners: "/icons/diners.svg",
  discover: "/icons/discover.svg",
  jcb: "/icons/jcb.svg",
  unionpay: "/icons/unionpay.svg",
  maestro: "/icons/maestro.svg",
  "cartes-bancaires": "/icons/cartes-bancaires.svg",
  dankort: "/icons/dankort.svg",
  elo: "/icons/elo.svg",
  hipercard: "/icons/hipercard.svg",
  uatp: "/icons/uatp.svg",
  vpay: "/icons/vpay.svg",

  // 💶 Bank debit & SEPA
  sepa_debit: "/icons/sepa.svg",

  // 💼 Wallets
  apple_pay: "/icons/apple-pay.svg",
  "google-pay": "/icons/google-pay.svg",
};

export const getPaymentIcon = (brand: string): string => {
  if (!brand) return "/icons/generic-card.svg";

  const normalized = brand.toLowerCase().replace(/\s+/g, "-");
  return paymentIcons[normalized] || "/icons/generic-card.svg";
};
